import { render } from "./messagesGame.vue?vue&type=template&id=b862ecf8"
import script from "./messagesGame.vue?vue&type=script&lang=js"
export * from "./messagesGame.vue?vue&type=script&lang=js"

import "./messagesGame.vue?vue&type=style&index=0&id=b862ecf8&lang=css"

import exportComponent from "/Users/robert.bryden/Documents/GitHub/BreakOutTheBox/webappV2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__